import { createSelector } from '@reduxjs/toolkit';
import { getWorkspaceById } from './workspaceSelectors';

const getCurrentWorkspaceIdFromStore = (state) => state.currentWorkspace.id;

// current workspace
export const getCurrentWorkspace = createSelector(
  getCurrentWorkspaceIdFromStore,
  (state) => state,
  (currentWorkspaceId, state) => getWorkspaceById(currentWorkspaceId)(state)
);

export const getCurrentWorkspaceId = () =>
  createSelector(
    getCurrentWorkspaceIdFromStore,
    (currentWorkspaceId) => currentWorkspaceId
  );
